var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 102,
    viewBox: "0 0 98 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.9473 46.0163H80.6215V53.5191H81.9473V46.0163Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M85.029 49.1058H77.5261V50.4316H85.029V49.1058Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3555 21.6743C43.0272 21.6743 57.6988 21.6743 72.3705 21.6743C75.6497 21.6743 78.3203 24.3449 78.3203 27.6241C78.3203 28.8073 78.3203 30.0243 78.3203 31.2075C78.3203 31.5117 78.1851 31.7822 77.9485 31.985C77.5766 32.2893 77.1709 32.5597 76.7991 32.864C76.9681 32.6949 77.0695 32.4583 77.0695 32.1878V28.6044C77.0695 25.3253 74.3989 22.6546 71.0859 22.6546H27.0709C25.7524 22.6546 24.5354 23.0941 23.5551 23.804C23.9607 23.4998 24.3664 23.1955 24.7721 22.8913C25.7862 22.1137 27.037 21.6743 28.3555 21.6743Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5165 78.0961C68.5165 79.9554 67.6376 81.7133 66.1501 82.8627C65.7444 83.167 65.305 83.505 64.8993 83.8093C66.3191 82.7275 67.2657 81.0034 67.2657 79.0427V33.1345H68.5503C68.5165 48.1442 68.5165 63.1202 68.5165 78.0961Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0693 28.6045V32.1879C77.0693 32.4583 76.9679 32.695 76.7989 32.864C76.6298 33.033 76.3932 33.1344 76.1227 33.1344H68.5503H67.2656V79.0764C67.2656 81.0034 66.3529 82.7275 64.8992 83.8431C63.8851 84.5868 62.6343 85.0601 61.282 85.0601H17.2669C13.9878 85.0601 11.3171 82.3894 11.3171 79.0764V75.493C11.3171 75.1888 11.4524 74.8845 11.689 74.7493C11.858 74.6141 12.0609 74.5465 12.2637 74.5465H21.1208V73.5661V28.6045C21.1208 26.6775 22.0336 24.9534 23.4872 23.8379C23.521 23.8041 23.521 23.8041 23.5548 23.7702C24.5352 23.0265 25.7522 22.6208 27.0706 22.6208H71.0857C74.3987 22.6547 77.0693 25.3253 77.0693 28.6045ZM74.9395 30.3962V28.6045C74.9395 26.4747 73.2155 24.7506 71.0857 24.7506C68.9559 24.7506 67.2318 26.4747 67.2318 28.6045V31.0385H74.2972C74.6691 31.0385 74.9395 30.768 74.9395 30.3962ZM66.5219 24.7506C53.3715 24.7506 40.221 24.7506 27.0706 24.7506C24.9409 24.7506 23.2168 26.4747 23.2168 28.6045C23.2168 45.4397 23.2168 62.2412 23.2168 79.0426C23.2168 80.4625 22.7097 81.8147 21.7969 82.8965C34.9474 82.8965 48.0978 82.8965 61.2482 82.8965C63.378 82.8965 65.1021 81.1724 65.1021 79.0426C65.1021 63.7286 65.1021 48.4484 65.1021 33.1344V28.6045C65.1359 27.2184 65.643 25.8324 66.5219 24.7506ZM21.1208 79.0764C21.1208 78.2651 21.1208 77.4538 21.1208 76.6762C18.7544 76.6762 16.388 76.6762 14.0554 76.6762C13.7173 76.6762 13.4131 76.9467 13.4131 77.2847C13.4131 77.8932 13.4131 78.4679 13.4131 79.0764C13.4131 81.2062 15.1372 82.9303 17.2669 82.9303C19.3967 82.9303 21.1208 81.2062 21.1208 79.0764Z",
    fill: "#D0D4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5144 73.566C16.0498 73.566 18.6224 73.566 21.1241 73.566V74.5464H12.2635C12.0607 74.5464 11.8579 74.614 11.6888 74.7492C12.1283 74.445 12.534 74.1069 12.9735 73.8027C13.1425 73.6337 13.3115 73.566 13.5144 73.566Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1209 76.6424C21.1209 77.4537 21.1209 78.2651 21.1209 79.0426C21.1209 81.1724 19.3968 82.8965 17.2671 82.8965C15.1373 82.8965 13.4132 81.1724 13.4132 79.0426C13.4132 78.4341 13.4132 77.8594 13.4132 77.2509C13.4132 76.9128 13.6837 76.6424 14.0555 76.6424C16.3881 76.6424 18.7545 76.6424 21.1209 76.6424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0751 63.8639C44.1427 63.8301 44.2441 63.8301 44.3117 63.8639C46.4077 65.419 48.5375 67.0079 50.6334 68.5629C50.9039 68.7658 51.2757 68.5629 51.2757 68.2587C51.2757 63.7287 51.2757 59.1649 51.2757 54.635C54.0816 51.7953 54.8929 47.5358 53.3379 43.851C51.7828 40.1661 48.1994 37.7659 44.1765 37.7659C40.1536 37.7659 36.5702 40.1661 35.0152 43.851C33.4601 47.5358 34.2714 51.7953 37.0773 54.635C37.0773 59.1649 37.0773 63.7287 37.0773 68.2587C37.0773 68.5968 37.4492 68.7658 37.7196 68.5629C39.8494 66.9741 41.9453 65.419 44.0751 63.8639ZM27.0708 24.7507C40.2213 24.7507 53.3717 24.7507 66.5221 24.7507C65.6094 25.8325 65.1023 27.1847 65.1023 28.6046V33.1345C65.1023 48.4485 65.1023 63.7625 65.1023 79.0427C65.1023 81.1725 63.3782 82.8966 61.2484 82.8966C48.098 82.8966 34.9476 82.8966 21.7971 82.8966C22.7099 81.8148 23.217 80.4626 23.217 79.0427C23.217 62.2413 23.217 45.406 23.217 28.6046C23.217 26.4748 24.9411 24.7507 27.0708 24.7507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9394 28.6046V30.3963C74.9394 30.7343 74.669 31.0386 74.2971 31.0386H67.2317V28.6046C67.2317 26.4748 68.9558 24.7507 71.0855 24.7507C73.2153 24.7507 74.9394 26.4748 74.9394 28.6046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0745 60.9903C44.1421 60.9227 44.2435 60.9227 44.3111 60.9903C45.7648 62.0721 47.2184 63.1539 48.6721 64.2019C48.8073 64.3033 48.9763 64.2019 48.9763 64.0328C48.9763 61.4636 48.9763 58.8944 48.9763 56.3251C46.0014 57.9816 42.3842 57.9816 39.4093 56.3251C39.4093 58.8944 39.4093 61.4636 39.4093 64.0328C39.4093 64.2019 39.6121 64.3033 39.7135 64.2019C41.1672 63.1539 42.6208 62.0721 44.0745 60.9903ZM53.3373 43.817C54.8923 47.5018 54.081 51.7613 51.2751 54.601C51.2751 59.131 51.2751 63.6948 51.2751 68.2247C51.2751 68.5628 50.9032 68.7318 50.6328 68.529C48.5368 66.9739 46.4071 65.3851 44.3111 63.83C44.2435 63.7962 44.1421 63.7962 44.0745 63.83C41.9785 65.3851 39.8488 66.9739 37.7528 68.529C37.4824 68.7318 37.1105 68.529 37.1105 68.2247C37.1105 63.6948 37.1105 59.131 37.1105 54.601C34.3046 51.7613 33.4933 47.5018 35.0483 43.817C36.6034 40.1322 40.1868 37.732 44.2097 37.732C48.2326 37.732 51.7822 40.1322 53.3373 43.817ZM51.816 47.6709C51.816 43.4451 48.4016 40.0308 44.1759 40.0308C39.9502 40.0308 36.5358 43.4451 36.5358 47.6709C36.5358 51.8966 39.9502 55.2771 44.1759 55.2771C48.4016 55.2771 51.816 51.8628 51.816 47.6709Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9764 56.359C48.9764 58.9282 48.9764 61.4975 48.9764 64.0667C48.9764 64.2357 48.8074 64.3372 48.6722 64.2357C47.2186 63.154 45.7649 62.0722 44.3113 61.0242C44.2436 60.9566 44.1422 60.9566 44.0746 61.0242C42.621 62.106 41.1673 63.1878 39.7137 64.2357C39.5785 64.3372 39.4094 64.2357 39.4094 64.0667C39.4094 61.4975 39.4094 58.9282 39.4094 56.359C42.3843 57.9817 45.9677 57.9817 48.9764 56.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8163 47.671C51.8163 43.4452 48.4019 40.0309 44.1762 40.0309C39.9505 40.0309 36.5361 43.479 36.5361 47.671C36.5361 51.8629 39.9505 55.2772 44.1762 55.2772C48.4019 55.2772 51.8163 51.8967 51.8163 47.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5795 46.6368C47.6396 46.6368 47.6696 46.7237 47.6396 46.7527C46.8889 47.274 46.1683 47.7954 45.4177 48.3167C45.3877 48.3457 45.3877 48.3747 45.3877 48.4036C45.6579 49.2436 45.9582 50.0836 46.2284 50.9236C46.2584 50.9815 46.1683 51.0394 46.1083 51.0104C45.3577 50.4891 44.6371 49.9677 43.8865 49.4464C43.8565 49.4174 43.8264 49.4174 43.7964 49.4464C43.0458 49.9677 42.3252 50.4891 41.5746 51.0104C41.5145 51.0394 41.4545 50.9815 41.4545 50.9236C41.7247 50.0836 42.025 49.2436 42.2952 48.4036C42.2952 48.3747 42.2952 48.3457 42.2651 48.3167C41.5145 47.7954 40.7939 47.274 40.0433 46.7527C39.9833 46.6947 40.0133 46.6368 40.1034 46.6368C41.0041 46.6368 41.9349 46.6368 42.8356 46.6368C42.8656 46.6368 42.8957 46.6078 42.8957 46.5789C43.1659 45.7389 43.4661 44.8989 43.7364 44.0589C43.7664 44.001 43.8565 44.001 43.8865 44.0589C44.1567 44.8989 44.4569 45.7389 44.7272 46.5789C44.7272 46.6078 44.7572 46.6368 44.7872 46.6368C45.748 46.6368 46.6788 46.6368 47.5795 46.6368Z",
    fill: "url(#paint6_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.3997 11.2495C55.3997 10.9456 55.3145 10.7046 55.1439 10.5267C54.9771 10.3451 54.6916 10.1784 54.2874 10.0264C53.8833 9.87444 53.5347 9.72434 53.2418 9.57609C52.9489 9.42413 52.6968 9.25179 52.4854 9.05906C52.2778 8.86263 52.1147 8.63284 51.996 8.3697C51.8811 8.10655 51.8236 7.79337 51.8236 7.43016C51.8236 6.80379 52.0238 6.29048 52.4243 5.8902C52.8247 5.48992 53.3568 5.25643 54.0205 5.18971V4H54.9103V5.20639C55.5666 5.29905 56.0801 5.57331 56.4509 6.02918C56.8217 6.48135 57.0071 7.06879 57.0071 7.79152H55.3997C55.3997 7.34676 55.3071 7.01505 55.1217 6.79638C54.94 6.57401 54.6953 6.46282 54.3875 6.46282C54.0835 6.46282 53.848 6.54992 53.6812 6.72411C53.5143 6.8946 53.4309 7.1318 53.4309 7.43571C53.4309 7.71739 53.5125 7.94347 53.6756 8.11396C53.8388 8.28445 54.141 8.45865 54.5822 8.63655C55.0271 8.81445 55.3923 8.98308 55.6778 9.14245C55.9633 9.29812 56.2043 9.47602 56.4008 9.67616C56.5974 9.87259 56.7475 10.0987 56.8513 10.3544C56.9552 10.6064 57.0071 10.9011 57.0071 11.2383C57.0071 11.8684 56.8106 12.3799 56.4175 12.7727C56.0245 13.1656 55.4832 13.3973 54.7935 13.4677V14.574H53.9092V13.4732C53.1491 13.3917 52.5596 13.123 52.1406 12.6671C51.7253 12.2075 51.5177 11.5979 51.5177 10.8381H53.125C53.125 11.2791 53.2288 11.6182 53.4365 11.8554C53.6478 12.0889 53.95 12.2057 54.343 12.2057C54.6693 12.2057 54.927 12.1204 55.1161 11.95C55.3052 11.7758 55.3997 11.5423 55.3997 11.2495Z",
    fill: "#A2ABC2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0011 36.5126C12.6586 36.5126 14.0023 35.169 14.0023 33.5115C14.0023 31.854 12.6586 30.5104 11.0011 30.5104C9.34365 30.5104 8 31.854 8 33.5115C8 35.169 9.34365 36.5126 11.0011 36.5126Z",
    fill: "#D0D4DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 69.5261,
    y: 42.0163,
    width: 27.5028,
    height: 27.5028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 3.31714,
    y: 0,
    width: 87.0032,
    height: 101.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 26.2682,
    y: 0,
    width: 42.7389,
    height: 84.6166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 32.0121,
    y: 40.0155,
    width: 27.6392,
    height: 27.0026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 0,
    y: 26.5104,
    width: 26.0023,
    height: 26.0023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80.6192,
    y1: 49.7689,
    x2: 81.9422,
    y2: 49.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 77.5231,
    y1: 49.7682,
    x2: 85.0283,
    y2: 49.7682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.5603,
    y1: 27.2683,
    x2: 78.3211,
    y2: 27.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 64.8996,
    y1: 58.4684,
    x2: 68.5504,
    y2: 58.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11.6898,
    y1: 74.1576,
    x2: 21.1242,
    y2: 74.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 34.268,
    y1: 53.176,
    x2: 54.1164,
    y2: 53.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 40.0121,
    y1: 47.5168,
    x2: 47.6513,
    y2: 47.5168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbLicenses);
export default __webpack_public_path__ + "static/media/thumb_licenses.7af91e2459fdc24ed8fb92e71321e932.svg";
export { ForwardRef as ReactComponent };